module.exports = __webpack_public_path__ + "assets/img/14-m.491d7c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/14-m.jpg
// module id = fO3U
// module chunks = 0